import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    optionsBar: {
      type: Object,
      default: null
    }
  },
  methods: {
    render() {
      setTimeout(() => {
        this.renderChart(this.chartdata, this.optionsBar);
      }, 100);
    }
  }
};
